<script lang="ts">
	import { getContext } from "svelte";
	import FieldError from "$form/Fields/Shared/FieldError.svelte";
	import Comment from "$form/Fields/Shared/Comment.svelte";
	import Label from "$form/Fields/Shared/Label.svelte";
	import Description from "$form/Fields/Shared/Description.svelte";

	import { createEventDispatcher, onMount } from "svelte";
	export let field: FieldDisplay & { type: "Comment" };
	export let value: string;
	const styling = getContext<Styling>("styling");

	let inputRef: HTMLTextAreaElement;
	const dispatch = createEventDispatcher();
	onMount(() => {
		inputRef.addEventListener("focus", () => {
			dispatch("updateOther", {
				active: true
			});
		});
		inputRef.addEventListener("blur", () => {
			dispatch("updateOther", {
				tainted: true
			});
			dispatch("updateOther", {
				active: false
			});
		});
	});
</script>

<div
	class="field-label-cover"
	class:has-placeholder="{styling.placeholders !== false}">
	{#if field.labelHTMLComputed && field.settings.hideLabel !== true}
		{#if styling.placeholders === false}
			<Label html="{field.labelHTMLComputed}" />
		{/if}
		{#if field.descriptionHTMLComputed}
			<Description html="{field.descriptionHTMLComputed}" />
		{/if}
	{/if}
</div>
<div class="field-input-cover">
	<Comment
		bind:element="{inputRef}"
		bind:value="{value}"
		field="{field}"
		placeholder="{styling.placeholders
			? field.labelComputed
			: (field.styling?.placeholder ?? '')}" />
	<FieldError
		visible="{field.tainted}"
		valid="{field.valid}"
		errorNumber="{field.errorNumber}"
		errorType="{field.errorType}" />
</div>
